// extracted by mini-css-extract-plugin
export const continueWrapper = "auth-module--continue-wrapper--14Ydh";
export const socialButtonsWrapper = "auth-module--social-buttons-wrapper--2WuXh";
export const divider = "auth-module--divider--1WSfw";
export const emailForm = "auth-module--email-form--1c7Ig";
export const authWrapper = "auth-module--auth-wrapper--2st6z";
export const closeButton = "auth-module--close-button--1Ez73";
export const banner = "auth-module--banner--1-LKG";
export const noBanner = "auth-module--no-banner--1uicc";
export const wrapper = "auth-module--wrapper--2Xbaq";
export const mainColumnWrapper = "auth-module--main-column-wrapper--16gIP";
export const headerWrapper = "auth-module--header-wrapper--3sN1F";
export const formWrapper = "auth-module--form-wrapper--1HVEm";
export const newPassword = "auth-module--new-password--1_L3P";
export const passwordField = "auth-module--password-field--1xmvL";
export const oldPassword = "auth-module--old-password--124TS";
export const passwordIconButton = "auth-module--password-icon-button--GtcHX";
export const bottomContent = "auth-module--bottom-content--1fn-f";
export const confirmationMsg = "auth-module--confirmation-msg--2I26O";